import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * to get key and value pairs of query paramters
 *
 * @returns object
 */
function useQueryParam() {
  const { search } = useLocation();

  return React.useMemo(() => {
    if (!search) return {};

    const obj = search
      .substring(1)
      .split('&')
      .reduce(function (prev: Record<string, any>, curr) {
        const p = curr.split('=');
        prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
        return prev;
      }, {});

    return obj;
  }, [search]);
}

export default useQueryParam;
